import PropTypes from 'prop-types'
import AlertComponent from '../stories/molecules/alerts'
import {
  alertAlignVariantOptions,
  alertOrientationVariantOptions,
  alertVariantComponentOptions
} from '../stories/molecules/alerts/constants'
import { buttonVariantOptions } from '../stories/atoms/button/constants'
import { FormattedMessage, useIntl } from 'react-intl'
import { NotAllowedItemsDescription, NotAllowedList } from './styled-components'

const NotAllowedMoveItemsAlert = ({
  isOpen = false,
  blockedItems = [],
  totalItems = 0,
  onClose = () => {},
  onMoveRemaining = () => {}
}) => {
  const { formatMessage } = useIntl()

  const hasItemMovedSuccessfully = blockedItems.length !== totalItems

  const message = hasItemMovedSuccessfully
    ? 'items_already_exist'
    : 'any_items_was_moved'

  const moveItemsButtonLabel = hasItemMovedSuccessfully
    ? 'move_remaining'
    : 'move_items'

  return (
    <AlertComponent
      isOpen={isOpen}
      variant={alertVariantComponentOptions.CONFIRMATION}
      title={formatMessage({ id: 'items_not_moved' })}
      buttonOrientation={alertOrientationVariantOptions.STACKED}
      buttonAlignment={alertAlignVariantOptions.CENTER}
      width="400px"
      activeOverlay={true}
      actionButtons={[
        {
          variant: buttonVariantOptions['TERTIARY-HOLLOW'],
          onClick: onMoveRemaining,
          children: formatMessage({ id: moveItemsButtonLabel }),
          fullWidth: true
        },
        {
          variant: buttonVariantOptions.PRIMARY,
          onClick: onClose,
          children: formatMessage({ id: 'done' }),
          fullWidth: true
        }
      ]}
    >
      <NotAllowedItemsDescription>
        <FormattedMessage
          id={message}
          values={{
            value: blockedItems.length,
            total: totalItems
          }}
        />

        <NotAllowedList>
          {blockedItems?.map((item) => (
            <li key={item.name}>{item.name}</li>
          ))}
        </NotAllowedList>
      </NotAllowedItemsDescription>
    </AlertComponent>
  )
}

NotAllowedMoveItemsAlert.propTypes = {
  isOpen: PropTypes.bool,
  blockedItems: PropTypes.array,
  totalItems: PropTypes.number,
  onClose: PropTypes.func,
  onMoveRemaining: PropTypes.func
}

export default NotAllowedMoveItemsAlert
